import React from 'react';
import i18next from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import { string } from 'prop-types';

import { DATA_TEST_ID } from '~constants/tests';
import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';
import { TARGETS } from '~redux/Order/constants';
import { dayFormat, nowIsBeforeThan } from '~utils/time';

import styles from './styles.module.scss';

const NowOrLaterButton = ({ templateModel }) => {
  const dispatch = useDispatch();
  const scheduledOrder = useSelector((state) => state.order[TARGETS.FUTURE_ORDER]);
  const openFutureOrderModal = () => dispatch(ModalActions.openModal(MODALS.FUTURE_ORDER));
  return (
    <button
      data-testid={DATA_TEST_ID.scheduledOrderOpenModal}
      onClick={openFutureOrderModal}
      className={styles[`nowOrLaterButton${templateModel}`]}
      type="button">
      {!scheduledOrder && i18next.t('FutureOrder:asap')}
      {scheduledOrder &&
        (nowIsBeforeThan(scheduledOrder?.date)
          ? dayFormat(scheduledOrder?.date, false, false, true)
          : scheduledOrder?.time)}
      <span className="m-left-1  material-icons-outlined">expand_more</span>
    </button>
  );
};

NowOrLaterButton.propTypes = {
  templateModel: string
};

export default NowOrLaterButton;
